module.exports = {
  "grid-option": {
    "justifyContent": "center",
    "borderRadius": 8,
    "borderWidth": 2,
    "paddingLeft": 6,
    "paddingRight": 6
  },
  "text-title": {
    "lines": 2,
    "lineHeight": 30,
    "textOverflow": "ellipsis",
    "textAlign": "center",
    "fontSize": 26
  },
  "image-checked": {
    "position": "absolute",
    "right": 0,
    "bottom": 0,
    "width": 38,
    "height": 34
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/style-loader.js!./node_modules/weex-vue-loader/lib/style-rewriter.js?id=data-v-7fc2e3f0!./node_modules/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-grid-select/option.vue
// module id = 59
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28